export default {"src":"/_next/static/media/favicon.c3da26f1.ico","height":100,"width":100};